module.exports = __webpack_public_path__ + "img/wait-payment.88f6fa3f.png";